import { render } from "./DebitVoucherList.vue?vue&type=template&id=6226f01c"
import script from "./DebitVoucherList.vue?vue&type=script&lang=js"
export * from "./DebitVoucherList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__